










import { Component, Prop, Vue } from 'vue-property-decorator'
import __ from '@/shared/helpers/__'
import PageHeader from '@/admin/components/PageHeader.vue'
import Form from '@/shared/components/form/Form.vue'
import FormBase from '@/shared/classes/form/form-base'
import Company from '@/shared/modules/company/company.model'
import { CompanyGetters } from '@/shared/store/company/company.getters'
import { GlobalActions } from '@/shared/store/global/global.actions'
import Task from '@/shared/modules/task/task.model'
import SearchableField from '@/shared/classes/form/fields/Select/searchable-field'
import Field, { FieldSizes } from '@/shared/classes/form/field'
import { FieldTypes } from '@/shared/components/form/field-types'
import FormGroup, { FormGroupTypes } from '@/shared/classes/form/group'
import ArrayField from '@/shared/classes/form/fields/array-field'
import _ from 'lodash'
import SelectField from '@/shared/classes/form/fields/Select/select-field'
import { HttpMethod } from '@/shared/helpers/requests.helper'
import TaskTypeFilesShowDialog from '@/company/components/task-types/TaskTypeFilesShowDialog.vue'
import ListTaskAttachments from '@/company/components/tasks/attachments/ListTaskAttachments.vue'

@Component({
  components: { Form, PageHeader },
  methods: { __ }
})
export default class ManagerShowTaskDialog extends Vue {
  @Prop() meta!: any
  static GROUP_DETAILS = 'details'
  static GROUP_PLANNED_TIME = 'planned-time'
  static GROUP_TASK_TYPES = 'task-types'
  static GROUP_ATTACHMENTS = 'attachments'
  static GROUP_MORE = 'more'
  static GROUP_COMMENTS = 'comments'
  static GROUP_ADDITIONAL = 'additional'
  static GROUP_MORE_ADDITIONAL = 'more-additional'

  form: FormBase | null = null

  created() {
    let fields = [
      new SearchableField()
        .setKey('responsible_uuid')
        .setEntryKey('responsibleUuid')
        .setTitle(__('company.components.tasks.add-task-dialog.form.worker'))
        .setGroup(ManagerShowTaskDialog.GROUP_DETAILS)
        .loadItems({ endpoint: `company/${ this.company.slug }/employees`, value: 'uuid', title: 'full_name', perPage: 20 })
        .setDisabled(true)
        .setSize(FieldSizes.half),
      new Field()
        .setType(FieldTypes.datePicker)
        .setKey('actual_date')
        .setEntryKey('actualDate')
        .setTitle(__('company.components.tasks.add-task-dialog.form.actual.date'))
        .setGroup(ManagerShowTaskDialog.GROUP_DETAILS)
        .setDisabled(true)
        .setSize(FieldSizes.half),
      new Field()
        .setType(FieldTypes.number)
        .setKey('planned_hours')
        .setEntryKey('plannedHours')
        .setTitle(__('company.components.tasks.add-task-dialog.form.planned.hours'))
        .setGroup(ManagerShowTaskDialog.GROUP_PLANNED_TIME)
        .setSize(FieldSizes.quarter)
        .setDisabled(true),
      new Field()
        .setType(FieldTypes.number)
        .setKey('planned_minutes')
        .setEntryKey('plannedMinutes')
        .setTitle(__('company.components.tasks.add-task-dialog.form.planned.minutes'))
        .setGroup(ManagerShowTaskDialog.GROUP_PLANNED_TIME)
        .setSize(FieldSizes.quarter)
        .setDisabled(true),
      new Field()
        .setType(FieldTypes.number)
        .setKey('planned_quantity')
        .setEntryKey('plannedQuantity')
        .setTitle(__('company.components.tasks.add-task-dialog.form.planned.quantity'))
        .setGroup(ManagerShowTaskDialog.GROUP_PLANNED_TIME)
        .setSize(FieldSizes.quarter)
        .setDisabled(true),
      new SearchableField()
        .setKey('planned_unit_uuid')
        .setEntryKey('plannedUnitUuid')
        .setTitle(__('company.components.tasks.add-task-dialog.form.planned.measure'))
        .loadItems({ endpoint: '/units', value: 'uuid', title: 'name', perPage: 20 })
        .setGroup(ManagerShowTaskDialog.GROUP_PLANNED_TIME)
        .setSize(FieldSizes.quarter)
        .setDisabled(true),
      new ArrayField()
        .setKey('task_times')
        .setEntryKey('taskTimes')
        .setGroup(ManagerShowTaskDialog.GROUP_TASK_TYPES)
        .setDense(true)
        .setFirstDelete(false)
        .setDisabled(true)
        .setChildren([
          new Field()
            .setType(FieldTypes.checkbox)
            .setKey('is_other_type')
            .setEntryKey('isOtherType')
            .setTooltip(__('company.components.tasks.add-task-dialog.form.task-types.is-other-type'))
            .setSize(FieldSizes.oneTwelfth)
            .setDisabled(true),
          new SearchableField()
            .setKey('task_type_uuid')
            .setEntryKey('taskTypeUuid')
            .setTitle(__('company.components.tasks.add-task-dialog.form.task-types.uuid'))
            .loadItems({ endpoint: `company/${ this.company.slug }/task-types`, value: 'uuid', title: 'name', perPage: 20 })
            .setVisibleIf((values: any, index: number|null) =>
              ! _.get(values, `task_times.${ index }.is_other_type`, true)
            )
            .setSize(FieldSizes.half)
            .setDisabled(true),
          new Field()
            .setKey('other_name')
            .setEntryKey('otherName')
            .setTitle(__('company.components.tasks.add-task-dialog.form.task-types.other-name'))
            .setVisibleIf((values: any, index: number|null) =>
              _.get(values, `task_times.${ index }.is_other_type`, true)
            )
            .setSize(FieldSizes.half)
            .setDisabled(true),
          new Field()
            .setType(FieldTypes.timePicker)
            .setKey('start_time')
            .setEntryKey('startTime')
            .setTitle(__('company.components.tasks.add-task-dialog.form.task-types.start-time'))
            .setSize(FieldSizes.twoHalfTwelfth)
            .setDisabled(true),
          new Field()
            .setType(FieldTypes.timePicker)
            .setKey('end_time')
            .setEntryKey('endTime')
            .setTitle(__('company.components.tasks.add-task-dialog.form.task-types.end-time'))
            .setMeta({
              minKey: (fullKey: string) => `${ fullKey }.start_time`
            })
            .setSize(FieldSizes.twoHalfTwelfth)
            .setDisabled(true),
          new Field()
            .setType(FieldTypes.custom)
            .setKey('photos')
            .setComponent(TaskTypeFilesShowDialog)
            .setValue([])
            .setSize(FieldSizes.oneTwelfth),
          new Field()
            .setType(FieldTypes.checkbox)
            .setKey('extra')
            .setTitle(__('company.components.tasks.add-task-dialog.form.task-types.extra'))
            .setDisabled(true)
            .setSize(FieldSizes.oneTwelfth)
        ]),
      new ArrayField()
        .setKey('comments')
        .setGroup(ManagerShowTaskDialog.GROUP_COMMENTS)
        .setDense(true)
        .setDisabled(true)
        .setChildren([
          new Field()
            .setKey('text')
            .setTitle(__('company.components.tasks.add-task-dialog.form.comments.comment'))
            .setDisabled(true),
        ]),
      new Field()
        .setType(FieldTypes.textArea)
        .setKey('notes')
        .setGroup(ManagerShowTaskDialog.GROUP_MORE_ADDITIONAL)
        .setTitle(__('company.components.tasks.add-task-dialog.form.comment'))
        .setSize(FieldSizes.full)
        .setDisabled(true),
      new SelectField()
        .setKey('status_uuid')
        .setEntryKey('statusUuid')
        .setTitle(__('company.components.tasks.add-task-dialog.form.status'))
        .loadItems({ endpoint: `statuses/model/${ Task.ALIAS }`, value: 'uuid', title: 'name' })
        .setGroup(ManagerShowTaskDialog.GROUP_ADDITIONAL)
        .setSize(FieldSizes.fourTwelfth)
        .setDisabled(true),
      new Field()
        .setType(FieldTypes.checkbox)
        .setKey('send_by_email')
        .setEntryKey('sendByEmail')
        .setMeta({
          class: 'd-flex align-center'
        })
        .setGroup(ManagerShowTaskDialog.GROUP_ADDITIONAL)
        .setSize(FieldSizes.eightTwelfth)
        .setTitle(__('company.components.tasks.add-task-dialog.form.send-by-email'))
        .setDisabled(true),
    ]

    if (! this.meta.project) {
      fields.unshift(
        new SearchableField()
          .setKey('project_uuid')
          .setEntryKey('projectUuid')
          .setDisabled(true)
          .setTitle(__('company.components.tasks.add-task-dialog.form.project'))
          .setGroup(ManagerShowTaskDialog.GROUP_DETAILS)
          .loadItems({ endpoint: `company/${ this.company.slug }/projects`, value: 'uuid', title: 'name', perPage: 20 }),
      )
    }

    this.form = new FormBase()
      .setUuid(this.meta.task.uuid)
      .setEndpoint(`company/${ this.company.slug }/tasks`)
      .setMethod(HttpMethod.PUT)
      .setModel(Task)
      .setGroups([
        new FormGroup()
          .setKey(ManagerShowTaskDialog.GROUP_DETAILS),
        new FormGroup()
          .setKey(ManagerShowTaskDialog.GROUP_PLANNED_TIME)
          .setTitle(__('company.components.tasks.add-task-dialog.form.groups.planned-time')),
        new FormGroup()
          .setKey(ManagerShowTaskDialog.GROUP_TASK_TYPES)
          .setTitle(__('company.components.tasks.add-task-dialog.form.groups.task-types')),
        new FormGroup()
          .setKey(ManagerShowTaskDialog.GROUP_ATTACHMENTS)
          .setComponent(ListTaskAttachments),
        new FormGroup()
          .setType(FormGroupTypes.accordion)
          .setKey(ManagerShowTaskDialog.GROUP_MORE)
          .setTitle(__('company.components.tasks.add-task-dialog.form.groups.more'))
          .setChildren([
            new FormGroup()
              .setKey(ManagerShowTaskDialog.GROUP_COMMENTS)
              .setTitle(__('company.components.tasks.add-task-dialog.form.groups.comments')),
            new FormGroup()
              .setKey(ManagerShowTaskDialog.GROUP_MORE_ADDITIONAL),
          ]),
        new FormGroup().setKey(ManagerShowTaskDialog.GROUP_ADDITIONAL),
      ])
      .setFields(fields)
      .setSubmit(false)
  }

  async closeDialog() {
    await this.$store.dispatch(GlobalActions.closeDialog)
  }

  get company(): Company {
    return this.$store.getters[CompanyGetters.getCompany]
  }
}
